import { lazy } from 'react';
import { Redirect } from 'react-router-dom';
// guards
import AuthGuard from '../guards/AuthGuard';
// layouts
import DashboardLayout from '../layouts/dashboard';
//
import { PATH_DASHBOARD, PATH_CLIENT } from './paths';

// ----------------------------------------------------------------------

const DashboardRoutes = {
  path: PATH_DASHBOARD.root,
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: PATH_DASHBOARD.root,
      component: () => <Redirect to={PATH_CLIENT.integration.accounts} />
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.cadence,
      component: lazy(() => import('../views/management/cadence/Cadences'))
    },    
    {
      exact: true,
      path: PATH_DASHBOARD.general.create,
      component: lazy(() => import('../views/configure/client/CreateClient'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.detail,
      component: lazy(() => import('../views/configure/client/DetailClient'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.map,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/EndpointMap'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.map_detail,
      component: lazy(() => import('../views/configure/subaccount/endpoint/EndpointDetail'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.cadence_detail,
      component: lazy(() => import('../views/configure/subaccount/cadence/CadenceDetail'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.versions,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/Versions'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.cp_map,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/ClientProductMap'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.said_map,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/SaidMapping'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.new_version,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/NewVersion'))
    },    
    {
      exact: true,
      path: PATH_DASHBOARD.general.edit_version,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/EditVersion'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.call_cadence_map,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/CallCadenceMap'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.duplicate_checks,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/DuplicateChecks'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.overrides,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/Overrides'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.csv,
      component: lazy(() => import('../views/configure/subaccount/endpoint/csv/UploadCSV'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.accounts,
      component: lazy(() => import('../views/configure/client/ClientAccount'))
    },
    {
      component: () => <Redirect to="/404" />
    }
  ]
};

export default DashboardRoutes;
